import { render, staticRenderFns } from "./portChargesAccount.vue?vue&type=template&id=0cd30768&scoped=true&"
import script from "./portChargesAccount.vue?vue&type=script&lang=js&"
export * from "./portChargesAccount.vue?vue&type=script&lang=js&"
import style0 from "./portChargesAccount.vue?vue&type=style&index=0&id=0cd30768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd30768",
  null
  
)

export default component.exports